<template>
  <div class="user">
    <!--添加等级-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加活动
      </el-button>
      <el-button size="small" type="primary" @click="getTableList">刷新
      </el-button>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="Id" width="50"></el-table-column>
          <el-table-column prop="name" label="活动名称" width="300"></el-table-column>
          <el-table-column prop="startTime" label="开始时间" width="165"></el-table-column>
          <el-table-column prop="endTime" label="结束时间" width="165"></el-table-column>
          <el-table-column prop="packetPrice" label="卡券金额"></el-table-column>
          <el-table-column prop="packetNum" label="卡券数量"></el-table-column>
          <el-table-column prop="limitationPrice" label="使用下限"></el-table-column>
          <el-table-column prop="validDay" label="有效期限(天)" width="110"></el-table-column>
          <el-table-column prop="extractCount" label="领券人数"></el-table-column>
          <el-table-column prop="status" label="活动状态">
            <template slot-scope="scope">
              <span>{{ getActivityStatus(scope.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="packetStatus" label="领券状态">
            <template slot-scope="scope">
              <span>{{ getPacketStatus(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="165"></el-table-column>
          <el-table-column fixed="right" label="操作" width="140">
            <template slot-scope="scope">
              <el-button @click="detailClick(scope.row)" type="text" size="small">详情
              </el-button>
              <el-button @click="editClick(scope.row)" type="text" size="small">编辑
              </el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                       :current-page="curPage"
                       :page-size="pageSize" layout="total, prev, pager, next, jumper"
                       :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close='dialogFormVisible'
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <el-form size="small" :model="userModel" ref="form" :rules="formRules" label-width="100px">
        <el-form-item label="活动名称：" prop="name">
          <el-input v-model="userModel.name" size="small" placeholder="活动名称"></el-input>
        </el-form-item>
        <el-form-item label="活动时间：" prop="startTime">
          <el-date-picker
            size="small"
            v-model="activityTime"
            type="datetimerange"
            value-format="yyyy-MM-dd hh:mm:ss"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="卡券前缀：" prop="packetNoPrefix">
          <el-input v-model="userModel.packetNoPrefix" size="small" placeholder="不填默认(NO)"></el-input>
        </el-form-item>
        <el-form-item label="卡券数量：" prop="packetNum">
          <el-input-number :min="0" v-model="userModel.packetNum" size="small" placeholder=""></el-input-number>
        </el-form-item>
        <el-form-item label="卡券金额：" prop="packetPrice">
          <el-input-number :min="0" v-model="userModel.packetPrice" size="small" placeholder=""></el-input-number>
          元
        </el-form-item>
        <el-form-item label="使用下限：" prop="packetPrice">
          <el-input-number :min="0" v-model="userModel.limitationPrice" size="small" placeholder=""></el-input-number>
          元
        </el-form-item>
        <el-form-item label="有限期限：" prop="packetPrice">
          <el-input-number :min="0" v-model="userModel.validDay" size="small" placeholder=""></el-input-number>
          天
        </el-form-item>

        <el-form-item label="活动封面" prop="coverId">
          <el-button @click="chooseImg('cover')">选择图片</el-button>
          <span class="m-l-15" style="color: #999999;font-size: 12px">建议图片：710 * 180</span>
          <img v-if="userModel.coverPath" class="mt10" v-img-url="userModel.coverPath" width="100">
        </el-form-item>
        <el-form-item label="内容图片" prop="coverId">
          <el-button @click="chooseImg('content')">选择图片</el-button>
          <div style="width: 100px;max-height: 150px;overflow: hidden">
            <img class="mt10" v-if="userModel.contentPath" v-img-url="userModel.contentPath" style="width: 100%">
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="addClickOK">确 定</el-button>
      </div>
    </el-dialog>
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 1 }" @returnImgs="returnImgsFunc"></Upload>
  </div>
</template>

<script>
import ActivityApi from '@/api/activity.js'
import {deepClone} from '@/utils/base.js'
import Upload from '@/components/file/Upload'

export default {
  name: 'index',
  components: {Upload},
  data () {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      dialogVisible: false,
      /*当前编辑的对象*/
      userModel: {
        id: 0,
        name: '',
        startTime: '',
        endTime: '',
        coverId: 0,
        contentId: 0,
        packetNoPrefix: '',
        packetNum: 1,
        packetPrice: 0.00,
        limitationPrice: 0.00,
        validDay: 0,
        coverPath: '',
        contentPath: ''
      },
      dialogTitle: '',
      formRules: {
        name: [{
          required: true,
          message: '标题不能为空',
          trigger: 'blur'
        }],
        startTime: [{
          required: true,
          message: '活动时间不能为空',
          trigger: 'change'
        }],
      },
      /*是否打开图片选择*/
      isupload: false,
      chooseType: ''
    }
  },
  computed: {
    activityTime: {
      get () {
        return [this.userModel.startTime || '', this.userModel.endTime || '']
      },
      set (e) {
        if (e && e.length > 1) {
          this.userModel.startTime = e[0] || ''
          this.userModel.endTime = e[1] || ''
        } else {
          this.userModel.startTime = ''
          this.userModel.endTime = ''
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getTableList()
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.curPage = val
      self.loading = true
      self.getTableList()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getTableList()
    },

    /*获取列表*/
    getTableList () {
      let self = this
      let Params = {}
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      ActivityApi.activityList(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.records
          self.totalDataNumber = res.data.total
        })
        .catch(error => {

        })
    },

    /*打开添加*/
    addClick () {
      this.userModel = {
        id: 0,
        name: '',
        startTime: '',
        endTime: '',
        coverId: 0,
        contentId: 0,
        packetNoPrefix: '',
        packetNum: 1,
        packetPrice: 0.00,
        limitationPrice: 0.00,
        validDay: 0,
        coverPath: '',
        contentPath: ''
      }
      this.dialogTitle = '添加活动'
      this.dialogVisible = true
    },

    /*打开编辑*/
    editClick (item) {
      this.userModel = deepClone(item)
      this.dialogTitle = '编辑活动'
      this.dialogVisible = true
    },

    detailClick (item) {
      this.$router.push({
        path: '/coupon/activity/detail',
        query: {
          activityId: item.id
        }
      })
    },

    /*删除用户*/
    deleteClick (row) {
      let self = this
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true
        ActivityApi.deleteActivity({id: row.tagId}, true)
          .then(data => {
            self.loading = false
            if (data.code == 1) {
              self.$message({
                message: data.msg,
                type: 'success'
              })
              self.getTableList()
            } else {
              self.$message.error('错了哦，这是一条错误消息')
            }
          })
          .catch(error => {
            self.loading = false
          })

      }).catch(() => {

      })
    },
    dialogFormVisible () {
      this.userModel = {
        id: 0,
        name: '',
        startTime: '',
        endTime: '',
        coverId: 0,
        contentId: 0,
        packetNoPrefix: '',
        packetNum: 1,
        packetPrice: 0.00,
        limitationPrice: 0.00,
        validDay: 0,
        coverPath: '',
        contentPath: ''
      }
    },
    addClickOK () {
      let self = this
      this.$refs.form.validate(valid => {
        if (valid) {
          if (self.userModel.id) {
            ActivityApi.editActivity(self.userModel, true).then(res => {
              if (res.code === 1) {
                self.getTableList()
                self.dialogVisible = false
              }
              self.$message({
                message: res.msg,
                type: 'success'
              })
            })
          } else {
            ActivityApi.addActivity(self.userModel, true).then(res => {
              if (res.code === 1) {
                self.getTableList()
                self.dialogVisible = false
              }
              self.$message({
                message: res.msg,
                type: 'success'
              })
            })
          }
        }
      })
    },
    chooseImg (type) {
      this.chooseType = type
      this.isupload = true
    },
    /*关闭选择图片*/
    returnImgsFunc (e) {
      this.isupload = false
      if (e != null && e.length > 0) {
        if (this.chooseType === 'cover') {
          this.userModel.coverId = e[0].fileId
          this.userModel.coverPath = e[0].filePath
        } else if (this.chooseType === 'content') {
          this.userModel.contentId = e[0].fileId
          this.userModel.contentPath = e[0].filePath
        }
      }
    },
    getActivityStatus (status) {
      let text = ''
      if (status === 0) {
        text = '未开始'
      } else if (status === 1) {
        text = '进行中'
      } else if (status === 2) {
        text = '已结束'
      }
      return text
    },
    getPacketStatus (row) {
      let text = ''
      let status = row.status
      let packetStatus = row.packetStatus
      if (status === 0) {
        text = '未开始'
      } else if (status === 1) {
        if (packetStatus === 0) {
          text = '未开始'
        } else if (packetStatus === 1) {
          text = '进行中'
        } else if (packetStatus === 2) {
          text = '已结束'
        }
      } else if (status === 2) {
        text = '已结束'
      }

      return text
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/coupon/activity/index.vue